import { MONTHS } from '../constants/dates';
import { DAYS } from '../constants/days';
import * as moment from 'moment';
import * as _ from 'lodash';

export const CalendarMixin = {
    data() {
        return {
            weekDays:  DAYS.map(this.formatWeekDay),
            days: [],
            date: new Date(),
            moment
        }
    },
    computed: {
        month() {
            return MONTHS[this.date.getMonth()];
        },
        year() {
            return this.date.getFullYear();
        },
    },
    methods: {
        getPreviousMonthDays() {
            const days = [];
            const firstDay = moment(this.date).date(1).toDate();
            const dayOffset = firstDay.getDay();
            if (dayOffset > 0) {
                const previousMonthDaysCount = moment(this.date).subtract(1, 'month').daysInMonth();
                for (let i = dayOffset ; i > 0; i--) {
                    const date = moment(this.date).subtract(1, 'month').date(previousMonthDaysCount - i + 1).toDate();
                    days.push(date);
                }
            }
            return days;
        },

        getCurrentMonthDays() {
            const days = [];
            const currentMonthDaysCount = moment(this.date).daysInMonth();;
            for (let i = 1; i <= currentMonthDaysCount; i++) {
                const date = moment(this.date).date(i).toDate();
                days.push(date);
            }
            return days;
        },

        getNextMonthDays() {
            const days = [];
            if (this.days.length % 7 !== 0) {
                const nextMonthDaysCount = 7 - _.last(this.days).getDay() - 1;
                for (let i = 1; i <= nextMonthDaysCount; i++) {
                    const date = moment(this.date).add(1, 'month').date(i).toDate();
                    days.push(date);
                }
            }
            return days;
        },

        showCalendar() {
            this.days = [];

            const previousMonthDays = this.getPreviousMonthDays();
            this.days.push(...previousMonthDays);

            const currentMonthDays = this.getCurrentMonthDays();
            this.days.push(...currentMonthDays);

            const nextMonthDays = this.getNextMonthDays(this.days.length);
            this.days.push(...nextMonthDays);
        },

        previousMonth() {
            this.date = moment(this.date).subtract(1, 'month').toDate();
        },

        nextMonth() {
            this.date = moment(this.date).add(1, 'month').toDate();
        },

        isCurrentMonthDay(day) {
            return moment(day).isSame(this.date, 'month');
        },

        isCurrentDate(day) {
            return moment(day).isSame(new Date(), 'date')
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/CalendarMixin.js